import {
  Button,
  Modal,
  Select,
  Checkbox,
  Image,
  Collapse,
  message,
  Form,
  Input,
  Radio,
  Switch,
} from "antd";
import React, { useState, useEffect } from "react";
import coparent from "../../Assets/Co-parent/Co-Parent-Calendar-Icon.png";
import "../../App.css";
import "../InviteCapture/Capture.css";
import "./Coparent.css";
import ReminderModalCoparent from "./ReminderModalCoparent";
import ColorDropdownWithName from "./ColorDropdownWithName";
import LearnMoreModal from "../../Components/LearnMore/LearnMoreModal";
import ReminderModal from "../Email/ReminderModal";
import {
  SearchOutlined,
  DeleteOutlined,
  CheckOutlined,
  EditOutlined,
  CloseOutlined,
  DownOutlined,
  RightOutlined,
  ScanOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import FloatLabel from "../FloatLabel"; // Import FloatLabel component
import ChooseDays from "./ChooseDays";
import ChooseTime from "./ChooseTime";
import CoParentCalender from "./CoParentCalender";
import CoParentCalendarNew from "./CoParentCalendarNew";

import { URL } from "../../helper/Mainurl";
import { get } from "lodash";
import { apiClient } from "../../utils/apiClient";
const { Panel } = Collapse;
const AddCoParent = ({}) => {
  const token = localStorage.getItem("authToken");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [metaData, setMetaData] = useState({});
  const [addParent, setAddParent] = useState(false);
  const [isModalOpenChooseTime, setIsModalOpenChooseTime] = useState(false);
  const [showParent1Details, setShowParent1Details] = useState(false);
  const [showParent2Details, setShowParent2Details] = useState(false);
  const [permissionOptions, setPermissionOptions] = useState([]);
  const [scheduleTypeOptions, setScheduleTypeOptions] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [setupId, setSetupId] = useState(null);
  const [parentCombinationsV2, setParentCombinationsV2] = useState([]);
  const [coParentsMetaData, setCoparentsMetaData] = useState({});
  const [stepOneData, setStepOneData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [coParents, setCoParents] = useState([
    {
      email: "",
      isExpanded: true,
      permission: 1,
      children: [],
      emailError: "",
      isAddingChild: false,
      newChildName: "",
      removedChildren: [],
    },
  ]);
  const [deletedCombinations, setDeletedCombinations] = useState([]);
  useEffect(() => {
    // console.log(parentCombinationsV2, "parentCombinationsV2");
  }, [parentCombinationsV2]);

  const [editingIndex, setEditingIndex] = useState({
    parent: null,
    child: null,
  });
  const [editModeName, setEditModeName] = useState("");
  const handleOpenModal = (comboId, childId = null, combo) => {
    console.log("handleOpenModal :::combo", { comboId, childId, combo });
    setActiveComboId(comboId);
    setActiveChildId(childId);
    setIsModalOpenChooseDay(true);
  };
  const sameScheduleForAllChange = (comboId, checked) => {
    setParentCombinations((prev) =>
      prev.map((c) =>
        c.id === comboId
          ? {
              ...c,
              sameScheduleForAll: checked,
              isSameScheduleForAll: checked ? 1 : 0,
            }
          : c
      )
    );
    setParentCombinationsV2((prev) =>
      prev.map((c) =>
        c.id === comboId
          ? {
              ...c,
              sameScheduleForAll: checked,
              isSameScheduleForAll: checked ? 1 : 0,
            }
          : c
      )
    );
    setSameScheduleForAll(checked ? 1 : 0);
  };
  // const handleOpenModalTime = (comboId, childId = null) => {
  //   console.log("handleOpenModalTime", comboId, childId);
  //   const comboV2 = parentCombinationsV2?.find(c => c?.id || c?.coparent_combination_id  == comboId);
  //    let childV2 = null;
  //  if(comboV2.isSameScheduleForAll && comboV2?.scheduleType && comboV2?.scheduleType?.id){

  //  }
  //   setActiveComboId(comboId);
  //   setActiveChildId(childId);
  //   setIsModalOpenChooseTime(true);
  // };

  const handleOpenModalTime = (comboId, childId = null) => {
    console.log("handleOpenModalTime", comboId, childId);
    const comboV2 = parentCombinationsV2?.find(
      (c) => (c?.id ?? c?.coparent_combination_id) == comboId
    );
    let childV2 = null;

    if (!comboV2) return;

    if (comboV2.isSameScheduleForAll) {
      // 1) If same schedule for all, require comboV2.scheduleType.id
      if (!(comboV2?.scheduleType && comboV2?.scheduleType?.id)) {
        // Show error or prevent modal
        message.warning("Please select a schedule type before setting times.");
        return;
      }
    } else {
      // 2) If not same schedule for all, require child.scheduleType.id
      childV2 = comboV2?.children?.find(
        (c) => (c?.id ?? c?.child_id) == childId
      );
      if (!(childV2?.scheduleType && childV2?.scheduleType?.id)) {
        message.warning(
          "Please select a schedule type for this child before setting times."
        );
        return;
      }
    }

    setActiveComboId(comboId);
    setActiveChildId(childId);
    setIsModalOpenChooseTime(true);
  };

  const handleCloseModalTime = () => setIsModalOpenChooseTime(false);

  const [value, setValue] = useState(1);

  const colorOptions = [
    { value: "#9b59b6" },
    { value: "#3498db" },
    { value: "#e74c3c" },
    { value: "#2ecc71" },
    { value: "#f39c12" },
    { value: "#e91e63" },
  ];

  const ColorDropdown = ({ value, onChange }) => (
    <Select
      value={value}
      onChange={onChange}
      bordered={false}
      suffixIcon={<DownOutlined />}
      style={{ width: 40, padding: 0, background: "transparent" }}
      dropdownStyle={{ padding: "6px 8px" }}
      options={colorOptions.map((color) => ({
        value: color.value,
        label: (
          <span
            style={{
              display: "inline-block",
              width: 20,
              height: 20,
              borderRadius: "50%",
              backgroundColor: color.value,
              border:
                value === color.value ? "2px solid #999" : "1px solid #ccc",
            }}
          />
        ),
      }))}
    />
  );
  const [isModalOpenChooseDay, setIsModalOpenChooseDay] = useState(false);
  const [activeComboId, setActiveComboId] = useState(null); // for combo.id
  const [activeChildId, setActiveChildId] = useState(null);
  const [notificationSettings, setNotificationSettings] = useState({
    push: 0,
    email: 0,
    calendar: 0,
    reminderEnabled: 0,
  });
  const [sameScheduleForAll, setSameScheduleForAll] = useState(0);
  const [reminder, setReminder] = useState(null);
  const [parentCombinations, setParentCombinations] = useState([
    {
      id: 1,
      parent1: { name: "Parent 5", email: "user1@gmail.com", color: "#9b59b6" },
      parent2: { name: "Parent 2", email: "user2@gmail.com", color: "#3498db" },
      children: [
        {
          id: 1,
          name: "Child 1",
          chooseDays: "Parent 1 on weekdays, Parent 2 on weekends",
          times:
            "Parent 1 from June 1st to June 15th, then Parent 2 from June 16th to June 30th",
        },
        {
          id: 2,
          name: "Child 2",
          chooseDays: "",
          times: "",
        },
      ],
    },
    {
      id: 2,
      parent1: { name: "Parent 5", email: "user1@gmail.com", color: "#9b59b6" },
      parent2: { name: "Parent 3", email: "user3@gmail.com", color: "#2ecc71" },
      children: [
        {
          id: 3,
          name: "Child 1",
          chooseDays: "",
          times: "",
        },
      ],
    },
  ]);
  const [inviteStatus, setInviteStatus] = useState(false);
  const [emailDeleted, setEmailDeleted] = useState(false);
  const [hasInvitesBeenSent, setHasInvitesBeenSent] = useState(
    () => localStorage.getItem("hasInvitesBeenSent") === "true"
  );
  const markInvitesSent = () => {
    setHasInvitesBeenSent(true);
    localStorage.setItem("hasInvitesBeenSent", "true");
  };
  const handleSaveDays = (
    parent1Days,
    parent2Days,
    scheduleType,
    isSameScheduleForAll
  ) => {
    setParentCombinations((prev) =>
      prev.map((combo) => {
        if (combo.id !== activeComboId) return combo;

        if (isSameScheduleForAll === 1) {
          const updatedChildren = combo.children.map((child) => ({
            ...child,
            parent1Days,
            parent2Days,
            scheduleType,
            schedule_type_id: scheduleType?.id,
          }));

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType,
            parent1: { ...combo.parent1, days: parent1Days },
            parent2: { ...combo.parent2, days: parent2Days },
            children: updatedChildren,
          };
        } else {
          const updatedChildren = combo.children.map((child) =>
            child?.id === activeChildId
              ? { ...child, parent1Days, parent2Days, scheduleType }
              : child
          );

          // remove `days` from parent1 and parent2
          const { days: _, ...cleanParent1 } = combo.parent1;
          const { days: __, ...cleanParent2 } = combo.parent2;

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType,
            parent1: cleanParent1,
            parent2: cleanParent2,
            children: updatedChildren,
          };
        }
      })
    );
    setParentCombinationsV2((prev) =>
      prev.map((combo) => {
        if (combo.id !== activeComboId) return combo;

        if (isSameScheduleForAll === 1) {
          const updatedChildren = combo.children.map((child) => ({
            ...child,
            parent1Days,
            parent2Days,
            scheduleType,
            schedule_type_id: scheduleType?.id,
          }));

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType,
            parent1: { ...combo.parent1, days: parent1Days },
            parent2: { ...combo.parent2, days: parent2Days },
            children: updatedChildren,
          };
        } else {
          const updatedChildren = combo.children.map((child) =>
            child?.id === activeChildId
              ? { ...child, parent1Days, parent2Days, scheduleType }
              : child
          );

          // remove `days` from parent1 and parent2
          const { days: _, ...cleanParent1 } = combo.parent1;
          const { days: __, ...cleanParent2 } = combo.parent2;

          return {
            ...combo,
            isSameScheduleForAll,
            scheduleType,
            parent1: cleanParent1,
            parent2: cleanParent2,
            children: updatedChildren,
          };
        }
      })
    );
  };

  const handleSaveTime = (data) => {
    const isSameScheduleForAll = Array.isArray(data); // 1 for all children, 0 for single child

    setParentCombinations((prevCombinations) =>
      prevCombinations.map((combo) => {
        if (isSameScheduleForAll) {
          const comboMatch = data.find((entry) => entry.comboId === combo.id);
          if (!comboMatch) return combo;

          return {
            ...combo,
            parent1: {
              ...combo.parent1,
              pickup: comboMatch.parent1.pickup,
              dropoff: comboMatch.parent1.dropoff,
            },
            parent2: {
              ...combo.parent2,
              pickup: comboMatch.parent2.pickup,
              dropoff: comboMatch.parent2.dropoff,
            },
            children: combo.children.map((child) => {
              // Remove pickup/dropoff from children
              const {
                parent1Pickup,
                parent1Dropoff,
                parent2Pickup,
                parent2Dropoff,
                ...rest
              } = child;
              return rest;
            }),
          };
        }

        // CASE: Individual child (sameScheduleForAll === 0)
        if (combo.id !== data.comboId) return combo;

        return {
          ...combo,
          // Clear combo-level parent1/parent2 pickup/dropoff
          parent1: {
            ...combo.parent1,
            pickup: undefined,
            dropoff: undefined,
          },
          parent2: {
            ...combo.parent2,
            pickup: undefined,
            dropoff: undefined,
          },
          children: combo.children.map((child) => {
            if (child.id !== data.childId) return child;

            return {
              ...child,
              parent1Pickup: data.parent1.pickup,
              parent1Dropoff: data.parent1.dropoff,
              parent2Pickup: data.parent2.pickup,
              parent2Dropoff: data.parent2.dropoff,
            };
          }),
        };
      })
    );

    setParentCombinationsV2((prevCombinationsV2) =>
      prevCombinationsV2.map((combo) => {
        if (isSameScheduleForAll) {
          const comboMatch = data.find((entry) => entry.comboId === combo.id);
          if (!comboMatch) return combo;

          return {
            ...combo,
            parent1: {
              ...combo.parent1,
              pickup: comboMatch.parent1.pickup,
              dropoff: comboMatch.parent1.dropoff,
            },
            parent2: {
              ...combo.parent2,
              pickup: comboMatch.parent2.pickup,
              dropoff: comboMatch.parent2.dropoff,
            },
            children: combo.children.map((child) => {
              // Remove pickup/dropoff from children
              const {
                parent1Pickup,
                parent1Dropoff,
                parent2Pickup,
                parent2Dropoff,
                ...rest
              } = child;
              return rest;
            }),
          };
        }

        // CASE: Individual child (sameScheduleForAll === 0)
        if (combo.id !== data.comboId) return combo;

        return {
          ...combo,
          // Clear combo-level parent1/parent2 pickup/dropoff
          parent1: {
            ...combo.parent1,
            pickup: undefined,
            dropoff: undefined,
          },
          parent2: {
            ...combo.parent2,
            pickup: undefined,
            dropoff: undefined,
          },
          children: combo.children.map((child) => {
            if (child.id !== data.childId) return child;

            return {
              ...child,
              parent1Pickup: data.parent1.pickup,
              parent1Dropoff: data.parent1.dropoff,
              parent2Pickup: data.parent2.pickup,
              parent2Dropoff: data.parent2.dropoff,
            };
          }),
        };
      })
    );

    // Optional debug logs
    if (isSameScheduleForAll) {
      console.log("Saved shared pickup/dropoff for all combos:");
      data.forEach(({ comboId, parent1, parent2 }) => {
        console.log(
          `Combo ${comboId} => Parent 1:`,
          parent1,
          "Parent 2:",
          parent2
        );
      });
    } else {
      const { comboId, childId, parent1, parent2 } = data;
      console.log(`Saved time for Combo ${comboId}, Child ${childId}`);
      console.log(
        "Parent 1 - Pickup:",
        parent1.pickup,
        "Dropoff:",
        parent1.dropoff
      );
      console.log(
        "Parent 2 - Pickup:",
        parent2.pickup,
        "Dropoff:",
        parent2.dropoff
      );
    }
  };
  const formatDaysDescription = (days) => {
    if (!days?.length) return "None";
    return days.join(", ");
  };

  const getCurrentParentDays = () => {
    const combo = parentCombinations.find((c) => c.id === activeComboId);
    if (!combo) return { parent1Days: [], parent2Days: [] };

    if (sameScheduleForAll) {
      return {
        parent1Days: combo.parent1.days || [],
        parent2Days: combo.parent2.days || [],
      };
    }

    const child = combo.children.find((c) => c.id === activeChildId);
    return {
      parent1Days: child?.parent1Days || [],
      parent2Days: child?.parent2Days || [],
    };
  };

  const updateParentFieldSet = (comboId, parentKey, field, value) => {
    setParentCombinations((prev) => {
      if (parentKey === "parent1" && field === "color") {
        // Set the same color for all parent1s
        return prev.map((combo) => ({
          ...combo,
          parent1: {
            ...combo.parent1,
            color: value, // Use name if available, otherwise use value directly
          },
        }));
      }

      // For all other fields, update normally
      return prev.map((combo) =>
        combo.id === comboId
          ? {
              ...combo,
              [parentKey]: {
                ...combo[parentKey],
                [field]: value,
              },
            }
          : combo
      );
    });
    setParentCombinationsV2((prev) => {
      if (parentKey === "parent1" && field === "color") {
        // Set the same color for all parent1s
        return prev.map((combo) => ({
          ...combo,
          parent1: {
            ...combo.parent1,
            color: value,
          },
        }));
      }

      // For all other fields, update normally
      return prev.map((combo) =>
        combo.id === comboId
          ? {
              ...combo,
              [parentKey]: {
                ...combo[parentKey],
                [field]: value,
              },
            }
          : combo
      );
    });
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  // useEffect(() => {
  //   setIsModalOpen(true); // open modal on mount
  // }, []);

  const style = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  // const permissionOptions = [
  //   {
  //     value: 1,
  //     label: (
  //       <div>
  //         <strong>Full Access</strong> – Can add, edit and remove events
  //       </div>
  //     ),
  //   },
  //   {
  //     value: 2,
  //     label: (
  //       <div>
  //         <strong>View-Only Access</strong> – Can only see events
  //       </div>
  //     ),
  //   },
  // ];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setStep(5);
  };

  // const onChangeSwitch = (checked) => {
  //   console.log(`switch to ${checked}`);
  // };
  const addCoParent = () => {
    if (coParents.length >= 2) {
      message.warning("You can only add up to 2 co-parents.");
      return;
    }
    const isValid = coParents.every(
      (parent) => parent.email && /\S+@\S+\.\S+/.test(parent.email)
    );

    if (!isValid) {
      message.error(
        "Please enter a valid email for all existing co-parents before adding another."
      );
      return;
    }

    // Set all existing parents' `isExpanded` to false before adding a new one
    const updatedCoParents = coParents.map((parent) => ({
      ...parent,
      isExpanded: false, // Collapse all existing parents
    }));

    // Add new co-parent with collapsed state
    setCoParents([
      ...updatedCoParents,
      {
        email: "",
        permission: 1,
        children: [],
        newChildName: "",
        isAddingChild: false,
        isExpanded: true, // New co-parent starts with collapsed state
        emailError: "",
      },
    ]);
  };

  const toggleExpand = (index) => {
    const updated = coParents.map((parent, i) => ({
      ...parent,
      isExpanded: i === index ? !parent.isExpanded : false, // Only toggle the clicked parent's expand state
    }));
    setCoParents(updated);
  };
  const removeCoParent = (index) => {
    setCoParents((prev) => {
      const updated = [...prev];
      const deletedParent = updated[index];

      // track backend combination for deletion
      if (deletedParent.combination_id) {
        setDeletedCombinations((prevDeleted) => [
          ...prevDeleted,
          deletedParent.combination_id,
        ]);
      }

      // reset UI slot so user can re-add
      updated[index] = {
        email: "",
        permission: 1,
        children: [],
        isAddingChild: false,
        newChildName: "",
        isExpanded: true,
        emailError: "",
        removedChildren: [],
        combination_id: null, // ensures treated as new if user fills again
      };

      return updated;
    });
    setEmailDeleted(true);
  };

  const handleEditChild = (parentIndex, childIndex) => {
    setEditingIndex({ parent: parentIndex, child: childIndex });
    setEditModeName(coParents[parentIndex].children[childIndex].name); // Load child’s name into the input field
  };
  const handleEditConfirm = (parentIndex, childIndex) => {
    const updated = [...coParents];
    const child = updated[parentIndex].children[childIndex];

    child.name = editModeName;

    // Mark as updated if it's an existing DB child
    if (child.child_id) {
      child.isUpdated = true;
    }

    setCoParents(updated);
    setEditingIndex({ parent: null, child: null });
    setEditModeName("");
  };
  const handleEditCancel = () => {
    // Reset the editing state for both parent and child
    setEditingIndex({ parent: null, child: null });

    // Clear the current child name from the edit input field
    setEditModeName("");
  };
  const handleDeleteChild = (parentIndex, childIndex) => {
    Modal.confirm({
      title: "Delete Child",
      content: "Are you sure you want to remove this child?",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => {
        setCoParents((prev) => {
          const updated = [...prev];
          const removedChild = updated[parentIndex].children[childIndex];

          if (removedChild.child_id) {
            updated[parentIndex].removedChildren = [
              ...(updated[parentIndex].removedChildren || []),
              removedChild,
            ];
          }

          updated[parentIndex].children.splice(childIndex, 1); // remove from active list
          return updated;
        });
      },
    });
  };
  const updateParentField = (index, field, value) => {
    const updated = [...coParents];
    updated[index][field] = value;

    // Basic validation for email
    if (field === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      updated[index].emailError = !emailRegex.test(value)
        ? "Please enter a valid email"
        : "";
    }

    setCoParents(updated);
  };
  useEffect(() => {
    if (
      reminder &&
      (reminder.days > 0 || reminder.hours > 0 || reminder.minutes > 0)
    ) {
      setNotificationSettings((prev) => ({
        ...prev,
        reminderEnabled: 1,
      }));
    }
    // console.log("setNotificationSettings", notificationSettings)
  }, [reminder]);
  const handleSubmit = async () => {
    // Basic email + children validation
    const hasInvalidEmail = coParents.some(
      (parent) => !parent.email || !/\S+@\S+\.\S+/.test(parent.email)
    );
    const hasEmptyChild = coParents.some((parent) =>
      parent.children.some((child) => !child.name.trim())
    );

    if (hasInvalidEmail || hasEmptyChild) {
      message.error("Please fill in all required fields correctly.");
      return;
    }

    const emptyChilds = coParents.some(
      (parent) => !parent.children || parent.children.length === 0
    );

    const isPermissionSelected = coParents.some(
      (parent) => parent.permission !== 1
    );
    if (!isPermissionSelected) {
      message.error("Please select permission access for co-parent.");
      return;
    }

    if (emptyChilds) {
      message.error(
        "Invite cannot be sent. Please add at least one child before sending the invite."
      );
      return;
    }

    const payload = {
      invitations: coParents.map((parent) => ({
        email: parent.email,
        feature: "co_parenting",
        permission_id: Number(parent.permission),
        children: parent.children.map((child) => ({ name: child.name })),
      })),
    };
    console.log("payload", payload);
    try {
      setLoading(true);
      // if you're using a spinner or disabling the button
      const response = await fetch(`${URL}/v1/invite/send`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        setInviteStatus(false);
        setLoading(false);
        throw new Error(
          result.message || "Failed to send invites. Please try again."
        );
      }
      setLoading(false);
      message.success("Invitations sent successfully!");
      setInviteStatus(true);
      markInvitesSent();
      getCoparentMetaData(true);
      setStep(3);
    } catch (error) {
      setLoading(false);
      setInviteStatus(false);
      console.error("Submission error:", error);
      message.error(
        error.message || "Failed to send invites. Please try again."
      );
    }
  };

  //Update Initial Setup except email
  const handleUpdate = async () => {
    const hasInvalidEmail = coParents.some(
      (parent) => !parent.email || !/\S+@\S+\.\S+/.test(parent.email)
    );
    const hasEmptyChild = coParents.some((parent) =>
      parent.children.some((child) => !child.name.trim())
    );

    if (hasInvalidEmail || hasEmptyChild) {
      message.error("Please fill in all required fields correctly.");
      return;
    }

    const emptyChilds = coParents.some(
      (parent) => !parent.children || parent.children.length === 0
    );

    if (emptyChilds) {
      message.error(
        "Invite cannot be sent. Please add at least one child to update the initial setup."
      );
      return;
    }
    const invitations = [];

    // 1. Deleted combinations
    if (deletedCombinations.length > 0) {
      invitations.push({
        action: "delete_combination",
        deleted_combination_ids: deletedCombinations,
      });
    }

    // 2. Active parents
    coParents.forEach((parent) => {
      if (!parent.email) return; // skip blank slot

      if (!parent.combination_id) {
        // new parent → send_invitation
        invitations.push({
          action: "send_invitation",
          email: parent.email,
          feature: "co_parenting",
          permission_id: Number(parent.permission),
          children: parent.children.map((child) => ({ name: child.name })),
        });
      } else {
        // existing parent → update_combination
        const add_children = parent.children
          .filter((child) => !child.child_id)
          .map((child) => ({ name: child.name }));

        const update_children = parent.children
          .filter((child) => child.child_id && child.isUpdated)
          .map((child) => ({
            child_id: child.child_id,
            name: child.name,
          }));

        const remove_children =
          parent.removedChildren?.map((child) => ({
            child_id: child.child_id,
          })) || [];

        invitations.push({
          action: "update_combination",
          combination_id: parent.combination_id,
          email: parent.email,
          feature: "co_parenting",
          permission_id: Number(parent.permission),
          ...(add_children.length > 0 && { add_children }),
          ...(update_children.length > 0 && { update_children }),
          ...(remove_children.length > 0 && { remove_children }),
        });
      }
    });

    const payload = { invitations };
    console.log("Final Payload:", payload);

    try {
      setLoading(true);
      const response = await fetch(
        `${URL}/v1/co-parenting/update-schedule-setup-step1`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        setLoading(false);
        throw new Error(
          result.message || "Failed to update. Please try again."
        );
      }
      setLoading(false);
      message.success("Initial setup updated successfully!");
      getCoparentMetaData(true);
      setStep(2);
    } catch (error) {
      setLoading(false);
      console.error("Submission error:", error);
      message.error(error.message || "Failed to update. Please try again.");
    }
  };
  const transformData = (data) => {
    console.log("transformData", JSON.parse(JSON.stringify(data)));
    return data.map((combo) => {
      if (combo) {
        // Handle cases where combo might be null or undefined
        const {
          id: coparent_combination_id,
          parent1,
          parent2,
          children,
          sameScheduleForAll,
        } = combo;

        return {
          coparent_combination_id,
          parent1: {
            nickname: parent1.name,
            email: parent1.email,
            color_id: parent1.color?.id || null,
          },
          parent2: {
            nickname: parent2.name,
            email: parent2.email,
            color_id: parent2.color?.id || null,
          },
          apply_same_settings_for_children: combo.isSameScheduleForAll ? 1 : 0,
          children: children
            .map((child, index) => {
              if (combo.isSameScheduleForAll && index !== 0) return;
              const {
                id: child_id,
                parent1: childParent1,
                parent2: childParent2,
              } = child;
              console.log(
                "child in transformData",
                child,
                combo.isSameScheduleForAll,
                index
              );
              if (
                combo.isSameScheduleForAll &&
                combo.scheduleType &&
                combo.scheduleType.id &&
                combo.scheduleType.id == 40
              ) {
                return {
                  child_id: child.id,
                  schedule_type_id: combo?.scheduleType?.id,
                  weeks: child.weeks || [],
                };
              }
              if (
                combo.isSameScheduleForAll &&
                combo.scheduleType &&
                combo.scheduleType.id &&
                combo.scheduleType.id == 41
              ) {
                console.log("child.week_schedules", child.week_schedules);
                const weeksObject = (child.week_schedules || []).reduce(
                  (acc, week) => {
                    const key = `week_number${week.week_number}`;
                    acc[key] = {
                      ...week,
                      ...(week.week_number === 1 && {
                        parent1_id: combo.parent1.user_id || null,
                      }),
                      ...(week.week_number === 2 && {
                        parent2_id: combo.parent2.user_id || null,
                      }),
                    };
                    return acc;
                  },
                  {}
                );
                return {
                  child_id,
                  schedule_type_id: 41,
                  child_name: child.name,
                  week_schedules: weeksObject,
                };
              }
              if (
                combo.isSameScheduleForAll &&
                combo.scheduleType &&
                combo.scheduleType.id &&
                combo.scheduleType.id == 42
              ) {
                return {
                  child_id,
                  schedule_type_id: 42,
                  parent1: {
                    parent1_id: combo.parent1.user_id || null,
                    apply_same_time_all_days:
                      childParent1.apply_same_time_all_days || 0,
                    selected_days: childParent1.selected_days || [],
                    responsible_for: childParent1.responsible_for || null,
                    pickup_time: childParent1.pickup_time || null,
                    days: childParent1.days || [],
                    dropoff_time: childParent1.dropoff_time || null,
                  },
                  parent2: {
                    parent2_id: combo.parent2.user_id || null,
                    apply_same_time_all_days:
                      childParent2.apply_same_time_all_days || 0,
                    selected_days: childParent2.selected_days || [],
                    responsible_for: childParent2.responsible_for || null,
                    pickup_time: childParent2.pickup_time || null,
                    days: childParent2.days || [],
                    dropoff_time: childParent2.dropoff_time || null,
                  },
                };
              }
              if (
                child.scheduleType &&
                child.scheduleType.id &&
                child.scheduleType.id == 40
              ) {
                return {
                  child_id,
                  schedule_type_id: 40,
                  weeks: child.weeks || [],
                };
              }
              if (
                child.scheduleType &&
                child.scheduleType.id &&
                child.scheduleType.id == 41
              ) {
                const weeksObject = (child.week_schedules || []).reduce(
                  (acc, week) => {
                    const key = `week_number${week.week_number}`;
                    acc[key] = {
                      ...week,
                      ...(week.week_number === 1 && {
                        parent1_id: combo.parent1.user_id || null,
                      }),
                      ...(week.week_number === 2 && {
                        parent2_id: combo.parent2.user_id || null,
                      }),
                    };
                    return acc;
                  },
                  {}
                );
                return {
                  child_id,
                  schedule_type_id: 41,
                  child_name: child.name,
                  week_schedules: weeksObject,
                };
              }
              if (
                child.scheduleType &&
                child.scheduleType.id &&
                child.scheduleType.id == 42
              ) {
                return {
                  child_id,
                  schedule_type_id: 42,
                  parent1: {
                    parent1_id: parent1.user_id,
                    apply_same_time_all_days:
                      childParent1.apply_same_time_all_days || 0,
                    selected_days: childParent1.selected_days || [],
                    responsible_for: childParent1.responsible_for || null,
                    pickup_time: childParent1.pickup_time || null,
                    days: childParent1.days || [],
                    dropoff_time: childParent1.dropoff_time || null,
                  },
                  parent2: {
                    parent2_id: parent2.user_id,
                    apply_same_time_all_days:
                      childParent2.apply_same_time_all_days || 0,
                    selected_days: childParent2.selected_days || [],
                    responsible_for: childParent2.responsible_for || null,
                    pickup_time: childParent2.pickup_time || null,
                    days: childParent2.days || [],
                    dropoff_time: childParent2.dropoff_time || null,
                  },
                };
              }
              // If none of the above, return null (will be filtered out)
              return null;
            })
            .filter(Boolean), // Remove null/undefined entries
        };
      }
    });
  };
  const handleSubmitSchedule = async () => {
    // Basic email + children validation
    // Function to convert the data into the desired payload format
    console.log("parentCombinationsV2", parentCombinationsV2);
    const transformedData = transformData(
      JSON.parse(JSON.stringify(parentCombinationsV2))
    );
    console.log("transformedData", { transformedData });
    let finalPayload = {
      couple: transformedData,
      setup_status: "schedule_saved",
    };
    // return
    try {
      setLoading(true);
      // if you're using a spinner or disabling the button
      const response = await fetch(`${URL}/v1/co-parenting/schedule-setup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(finalPayload),
      });

      if (!response.ok) {
        setLoading(false);
        throw new Error("Failed to schedule setup");
      }
      setLoading(false);
      const result = await response.json();
      message.success("Schedule saved successfully");
      console.log("Response:", result);

      // Reset or close modal here
      setCoParents([
        {
          email: "",
          isExpanded: true,
          permission: 1,
          children: [],
          emailError: "",
          isAddingChild: false,
          newChildName: "",
        },
      ]);
      getCoparentMetaData();
    } catch (error) {
      setLoading(false);
      console.error("Submission error:", error);
      message.error(
        error.message || "Failed to send invites. Please try again."
      );
    }
    return;
    const convertToPayload = (data) => {
      // Helper to decide flags based on days and times
      const getScheduleFlags = (days, pickupTime, dropoffTime) => {
        return {
          is_choose_days_enabled:
            Array.isArray(days) && days.length > 0 ? 1 : 0,
          is_pick_and_drop_off_enabled: pickupTime || dropoffTime ? 1 : 0,
        };
      };

      return {
        couples: data.map((item) => {
          const parent1UserId = item.parent1.user_id;
          const parent2UserId = item.parent2.user_id;

          const parentColors = [
            {
              parent1_id: parent1UserId,
              color_id: item.parent1?.color?.id || null,
            },
            {
              parent2_id: parent2UserId,
              color_id: item.parent2?.color?.id || null,
            },
          ];

          const childIds =
            item.isSameScheduleForAll === 1
              ? item.children.map((child) => child.id)
              : null;

          const schedules =
            item.isSameScheduleForAll === 1
              ? [
                  {
                    parent_schedules: [
                      {
                        parent1_id: parent1UserId || null,
                        ...getScheduleFlags(
                          item.parent1?.days,
                          item.parent1?.pickup?.time,
                          item.parent1?.dropoff?.time
                        ),
                        schedule_type_id: item?.scheduleType?.id || null,
                        pickup_days: item.parent1?.days || null,
                        pickup_time: item.parent1?.pickup?.time || null,
                        dropoff_days: item.parent1?.days || null,
                        dropoff_time: item.parent1?.dropoff?.time || null,
                      },
                      {
                        parent2_id: parent2UserId || null,
                        ...getScheduleFlags(
                          item.parent2?.days,
                          item.parent2?.pickup?.time,
                          item.parent2?.dropoff?.time
                        ),
                        schedule_type_id: item?.scheduleType?.id || null,
                        pickup_days: item.parent2?.days || null,
                        pickup_time: item.parent2?.pickup?.time || null,
                        dropoff_days: item.parent2?.days || null,
                        dropoff_time: item.parent2?.dropoff?.time || null,
                      },
                    ],
                  },
                ]
              : item.children.map((child) => ({
                  child_id: child.id,
                  parent_schedules: [
                    {
                      parent1_id: parent1UserId || null,
                      ...getScheduleFlags(
                        child?.parent1Days,
                        child?.parent1Pickup?.time,
                        child?.parent1Dropoff?.time
                      ),
                      schedule_type_id: item?.scheduleType?.id || null,
                      pickup_days: child?.parent1Days || null,
                      pickup_time: child?.parent1Pickup?.time || null,
                      dropoff_days: child?.parent1Days || null,
                      dropoff_time: child?.parent1Dropoff?.time || null,
                    },
                    {
                      parent2_id: parent2UserId || null,
                      ...getScheduleFlags(
                        child?.parent2Days,
                        child?.parent2Pickup?.time,
                        child?.parent2Dropoff?.time
                      ),
                      schedule_type_id: item?.scheduleType?.id || null,
                      pickup_days: child?.parent2Days || null,
                      pickup_time: child?.parent2Pickup?.time || null,
                      dropoff_days: child?.parent2Days || null,
                      dropoff_time: child?.parent2Dropoff?.time || null,
                    },
                  ],
                }));

          return {
            is_shared_across_children: item.isSameScheduleForAll === 1 ? 1 : 0,
            primary_user_coparent_id: item.id,
            primary_user_nickname: item.parent1.name,
            co_parent_nickname: item.parent2.name,
            parent_colors: parentColors,
            child_ids: childIds,
            schedules: schedules,
          };
        }),
      };
    };

    // Convert the data to payload format
    const payload = convertToPayload(parentCombinations); // Assuming `parentCombinations` is available from props or state
    console.log("Final Payload", payload);
    try {
      // if you're using a spinner or disabling the button
      const response = await fetch(`${URL}/v1/co-parenting/schedule-setup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to send invitations");
      }

      const result = await response.json();
      message.success("Schedule setup created successfully!");
      console.log("Response:", result);

      // Reset or close modal here
      setCoParents([
        {
          email: "",
          isExpanded: true,
          permission: 1,
          children: [],
          emailError: "",
          isAddingChild: false,
          newChildName: "",
        },
      ]);
      getCoparentMetaData();
    } catch (error) {
      console.error("Submission error:", error);
      message.error("Failed to send invites. Please try again.");
    } finally {
    }
  };
  const handleSelect = (selectedChild) => {
    console.log("Selected child:", selectedChild);
  };
  const handleSkip = () => {
    console.log("Skipping co-parent invite");
    if (metaData && metaData.couples && metaData.couples.length) {
      setStep(3);
    } else {
      setStep(4);
    }
  };
  const handleEditClick = (parentIndex, childIndex) => {
    setEditingIndex({ parent: parentIndex, child: childIndex });
    setEditModeName(coParents[parentIndex].children[childIndex].name);
  };
  const handleAddChild = (index) => {
    const updated = [...coParents];
    updated[index] = {
      ...updated[index],
      isAddingChild: true,
      newChildName: "", // Ensure this is initialized
    };
    setCoParents(updated);
  };

  const handleChildInputChange = (index, value) => {
    const updated = [...coParents];
    updated[index].newChildName = value;
    setCoParents(updated);
  };
  const getTimeSechudule = (comboId, childId = null) => {
    const comboV2 = parentCombinationsV2?.find(
      (c) => c?.id || c?.coparent_combination_id == comboId
    );
    let childV2 = null;
    if (comboV2.isSameScheduleForAll) {
      childV2 = comboV2?.children?.[0]; // If same schedule for all, just get the first child
      if (
        comboV2?.scheduleType &&
        comboV2?.scheduleType?.id &&
        comboV2?.scheduleType?.id == 40
      ) {
        if (childV2?.weeks && childV2?.weeks?.length) {
          return true;
        } else {
          return false;
        }
      }
      if (
        comboV2?.scheduleType &&
        comboV2?.scheduleType?.id &&
        comboV2?.scheduleType?.id == 41
      ) {
        if (childV2?.week_schedules && childV2?.week_schedules?.length) {
          return true;
        } else {
          return false;
        }
      }
      if (
        comboV2?.scheduleType &&
        comboV2?.scheduleType?.id &&
        comboV2?.scheduleType?.id == 42
      ) {
        if (
          childV2?.parent1?.selected_days &&
          childV2?.parent2?.selected_days
        ) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      childV2 = comboV2?.children?.find(
        (c) => (c?.id || c?.child_id) == childId
      );
    }
    //  const childV2 = comboV2?.children?.find(c => c?.id || c?.child_id  == childId);
    if (
      (childV2?.scheduleType || childV2?.scheduleType?.label) &&
      childV2?.scheduleType?.id &&
      childV2?.scheduleType?.id == 40
    ) {
      if (childV2?.weeks && childV2?.weeks?.length) {
        return true;
      } else {
        return false;
      }
    }
    if (
      (childV2?.scheduleType || childV2?.scheduleType?.label) &&
      childV2?.scheduleType?.id &&
      childV2?.scheduleType?.id == 41
    ) {
      if (childV2?.week_schedules && childV2?.week_schedules?.length) {
        return true;
      } else {
        return false;
      }
    }
    if (
      (childV2?.scheduleType || childV2?.scheduleType?.label) &&
      childV2?.scheduleType?.id &&
      childV2?.scheduleType?.id == 42
    ) {
      if (childV2?.parent1?.selected_days && childV2?.parent2?.selected_days) {
        return true;
      } else {
        return false;
      }
    }
  };

  const handleConfirmAddChild = (index) => {
    const updated = [...coParents];
    const name = updated[index].newChildName.trim();
    if (!name) return;

    // Always push as a new child (no child_id, no isUpdated)
    updated[index].children.push({
      name,
      child_id: null, // make it explicit so filter works cleanly
      isUpdated: false, // new children should never be marked as updated
    });

    updated[index].isAddingChild = false;
    updated[index].newChildName = "";
    setCoParents(updated);
  };

  const handleCancelAddChild = (index) => {
    const updated = [...coParents];
    updated[index].isAddingChild = false;
    updated[index].newChildName = "";
    setCoParents(updated);
  };

  const getCoparentMetaData = async () => {
    try {
      const response = await apiClient.get("/v1/co-parenting/metadata");
      const data = response.data;
      setCoparentsMetaData(data.data);
      if (data.code == 200) {
        const {
          permissions,
          features,
          colors,
          schedule_types,
          couples,
          user_as_coparent_couples,
          setup_info,
        } = data.data;

        if (user_as_coparent_couples && user_as_coparent_couples.length) {
          setStep(5);
          return;
        }
        if (setup_info) {
          if (setup_info.status && setup_info.notification_status) {
            setIsModalOpen(false);
            setStep(5);
          } else {
            if (!setup_info.notification_status && setup_info.status) {
              setIsModalOpen(true);
              setStep(4);
            } else {
              if (couples && couples.length) {
                setIsModalOpen(true);
                setStep(3);
              } else {
                setIsModalOpen(true);
                setStep(1);
              }
            }
          }
        } else {
          setIsModalOpen(true);
          setStep(1);
        }

        // Permissions with rich label
        const permissionOptions = permissions.map((perm) => ({
          value: perm.id,
          label: (
            <div>
              <strong>{perm.name}</strong>
              {perm.description ? ` – ${perm.description}` : ""}
            </div>
          ),
        }));

        // Features (e.g., for checkbox or select)
        const featureOptions = features.map((feature) => ({
          value: feature.key,
          label: feature.label,
        }));

        // Colors (use for color selection UI)
        const colorOptions = colors.map((color) => ({
          value: color.id,
          label: color.label_name, // you might render color swatches instead
        }));

        // Schedule Types
        const scheduleTypeOption = schedule_types.map((type) => ({
          value: type.id,
          label: type.label_name,
        }));
        let customParentIndex = 2;

        const formattedParentCombinations = (
          couples && couples.length > 0 ? couples : user_as_coparent_couples
        ).map((couple) => {
          let parent2Name = couple.parent2?.name;

          if (!parent2Name || parent2Name === "") {
            parent2Name = `Parent ${customParentIndex++}`;
          }

          return {
            id: couple.id,
            parent1: {
              name: couple.parent1?.name || `Parent 1`,
              email: couple.parent1?.email || "",
              color: couple.parent1?.color || { id: null, name: "#ccc" },
              user_id: couple.parent1?.user_id || null,
            },
            parent2: {
              name: parent2Name,
              email: couple.parent2?.email || "",
              color: couple.parent2?.color || { id: null, name: "#ccc" },
              user_id: couple.parent2?.user_id || null,
            },
            children: (couple.children || []).map((child) => ({
              id: Number(child.id),
              name: child.name,
              chooseDays: "",
              times: "",
              parent1: {},
              parent2: {},
            })),
            sameScheduleForAll: false,
          };
        });
        setMetaData(data.data);
        setParentCombinations(formattedParentCombinations);
        setParentCombinationsV2(formattedParentCombinations);
        // Update state
        setPermissionOptions(permissionOptions);
        setScheduleTypeOptions(scheduleTypeOption);
        // setPriority(data.data.priority)
        // setRadioMeta(data.data.progress_status)
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };
  useEffect(() => {
    getCoparentMetaData();
    // console.log("response>>>>>", parentCombinations);
  }, []);

  const handleSaveReminder = (value) => {
    console.log("Selected co-parent reminder:", value);
    setReminder(value);
    // handle save logic here
  };
  const saveNotification = async () => {
    // Calculate reminder offset (in minutes)
    const reminderOffset =
      (reminder?.days || 0) * 24 * 60 +
      (reminder?.hours || 0) * 60 +
      (reminder?.minutes || 0);

    const payload = {
      is_push_notification_enabled: notificationSettings.push,
      is_email_summaries_enabled: notificationSettings.email,
      is_calendar_sync_enabled: notificationSettings.calendar,
      is_reminder_enabled: notificationSettings.reminderEnabled ? 1 : 0,
      reminder_offset: notificationSettings.reminder_offset || null,
      notification_setup_status: "completed",
    };
    // console.log("update-schedule-setup-step3:", payload);
    // return;
    try {
      setLoading(true);
      const response = await fetch(
        `${URL}/v1/co-parenting/notification-setup`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        setLoading(false);
        const errorData = await response.json();
        console.error("API Error Response:", errorData);
        throw new Error("Failed to save notification settings.");
      }
      setLoading(false);
      const result = await response.json();
      console.log("Saved successfully:", result);
      closeModal(true);

      // Proceed to next step
      setStep(5);
    } catch (error) {
      setLoading(false);
      console.error("Save failed:", error.message || error);
    }
  };

  const getAllUsedColors = () => {
    const usedColors = [];
    parentCombinations.forEach((combo) => {
      if (combo.parent1.color?.name) usedColors.push(combo.parent1.color.name);
      if (combo.parent2.color?.name) usedColors.push(combo.parent2.color.name);
    });
    return usedColors;
  };
  const skipAndClose = () => {
    setStep(5);
    closeModal();
  };
  const getCoparentEdit = async () => {
    try {
      const response = await fetch(
        `${URL}/v1/co-parenting/view-setup/step-one`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.code == 200) {
        const transformedData = result.data.map((item) => ({
          email: item.parent2.email,
          permission: item.parent2.permissions[0]?.id || null,
          children: item.children.map((child) => ({
            child_id: child.id,
            name: child.name,
          })),
          isExpanded: false,
          emailError: "",
          isAddingChild: false,
          newChildName: "",
          combination_id: item.id || item.coparent_combination_id,
          removedChildren: [],
        }));
        setCoParents(transformedData);
        setStepOneData(transformedData);

        // console.log("Transformed Co-parent Data:", transformedData);

        // You can now use `transformedData` to set state or further processing
        // Example: setCoparents(transformedData);
      } else {
        console.error("Invalid response from server:", result);
      }
    } catch (error) {
      console.error("Error fetching co-parent data:", error);
    }
  };

  useEffect(() => {
    if (metaData?.couples?.length > 0 && metaData.couples[0]?.parent2?.email) {
      getCoparentEdit();
      markInvitesSent();
    }
  }, [step, metaData]);

  return (
    <>
      <div>{/* <Button onClick={showModal}>Co-Parent</Button> */}</div>
      <div>
        <Modal
          title="Co-Parent"
          open={isModalOpen}
          onCancel={closeModal}
          footer={false}
          onOk={handleOk}
        >
          {step === 1 && (
            <>
              <div className="modal-content">
                <h2 className="modal-title">Co-Parenting Made Simple</h2>
                <p className="modal-description">
                  Easily manage your child’s schedule with a shared calendar for
                  seamless co-parenting
                </p>
                <img
                  src={coparent}
                  width={180}
                  style={{ marginBottom: "10px" }}
                />

                <Button
                  type="primary"
                  className="modal-btn"
                  onClick={() => setStep(2)}
                >
                  Set Up Now{" "}
                </Button>
                {/* <Button className="modal-btn">Learn More</Button> */}
                <LearnMoreModal
                  moduleName="co_parenting_calendar"
                  buttonType="default"
                  buttonClass="modal-btn"
                />
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <div className="modal-content">
                <div
                  className="modal-content"
                  style={{
                    marginBottom: "30px",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "20px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <h2
                      className="modal-title-step2"
                      style={{ textAlign: "center" }}
                    >
                      Invite Co-Parent
                    </h2>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p className="modal-description">
                      Both parents can add and manage events
                    </p>
                    <img
                      src={coparent}
                      width={180}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  {coParents.map((parent, index) => {
                    if (!parent) return null;
                    return (
                      <div key={index} style={{ width: "100%" }}>
                        {parent.email && !parent.emailError && (
                          <div className="username-box-1">
                            <Button
                              // style={{ width: "100%" }}
                              onClick={() => toggleExpand(index)}
                            >
                              {parent.email} <EditOutlined />
                            </Button>
                            {/* <Button
                              className="deleteIcon"
                              icon={<DeleteOutlined />}
                              onClick={() => removeCoParent(index)}
                            /> */}
                          </div>
                        )}
                        {parent.isExpanded && (
                          <>
                            <div className="coparent-div-1">
                              <h4>Enter Co-Parent’s Email Address</h4>
                              <Form.Item
                                name={`email-${index}`}
                                validateStatus={
                                  parent.emailError ? "error" : ""
                                }
                                help={parent.emailError}
                                rules={[
                                  {
                                    required: true,
                                    type: "email",
                                    message: "Please enter a valid email",
                                  },
                                ]}
                              >
                                <FloatLabel
                                  label="Email"
                                  value={parent.email}
                                  required
                                >
                                  <Input
                                    value={parent.email}
                                    placeholder=""
                                    disabled={
                                      hasInvitesBeenSent && !emailDeleted
                                    }
                                    style={{ width: "100%" }}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      updateParentField(index, "email", value);
                                    }}
                                  />
                                </FloatLabel>
                              </Form.Item>
                            </div>

                            <div className="coparent-div">
                              <h4>
                                Permission Settings{" "}
                                <span style={{ color: "red" }}>*</span>
                              </h4>
                              <Radio.Group
                                options={permissionOptions}
                                value={Number(parent.permission)}
                                // disabled={inviteStatus}
                                onChange={(e) =>
                                  updateParentField(
                                    index,
                                    "permission",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            <div className="addChildrenSection">
                              <h4>
                                Add Child(ren) Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </h4>

                              {parent.children.map((child, childIndex) => (
                                <div
                                  key={childIndex}
                                  style={{
                                    marginBottom: "10px",
                                    display: "inline-flex",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  {editingIndex.parent === index &&
                                  editingIndex.child === childIndex ? (
                                    <>
                                      <input
                                        type="text"
                                        // disabled={inviteStatus}
                                        value={editModeName}
                                        className="childtext"
                                        onChange={(e) =>
                                          setEditModeName(e.target.value)
                                        }
                                        style={{
                                          padding: "15px",
                                          width: "100%",
                                          border: "1px solid #9A4FE0",
                                          fontSize: "14px",
                                        }}
                                      />
                                      <button
                                        className="confirnIcon"
                                        onClick={() =>
                                          handleEditConfirm(index, childIndex)
                                        }
                                        style={{
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        ✓
                                      </button>
                                      <button
                                        className="confirnIcon"
                                        onClick={handleEditCancel}
                                        style={{
                                          marginLeft: "5px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        ✕
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <span
                                        className="childEdit"
                                        style={{
                                          width: "100%",
                                          fontSize: "14px",
                                          padding: "15px",
                                          backgroundColor: "#F7F8FA",
                                          borderRadius: "6px",
                                          border: "1px solid #E1E6EF",
                                        }}
                                      >
                                        {child.name}
                                      </span>
                                      <button
                                        className="confirnIcon test"
                                        onClick={() =>
                                          handleEditClick(index, childIndex)
                                        }
                                        // disabled={inviteStatus}
                                        style={{
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <EditOutlined />
                                      </button>
                                      <button
                                        className="confirnIcon"
                                        onClick={() =>
                                          handleDeleteChild(index, childIndex)
                                        }
                                        // disabled={inviteStatus}
                                        style={{
                                          marginLeft: "5px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </button>
                                    </>
                                  )}
                                </div>
                              ))}

                              {parent.isAddingChild ? (
                                <div
                                  className="new123"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "10px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder="Enter child's name"
                                    className="childtext"
                                    value={parent.newChildName}
                                    onChange={(e) =>
                                      handleChildInputChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      padding: "12px",
                                      width: "100%",
                                      border: "1px solid #9A4FE0",
                                      fontSize: "14px",
                                      borderRadius: "4px",
                                    }}
                                  />
                                  <button
                                    className="confirnIcon"
                                    onClick={() => handleConfirmAddChild(index)}
                                    style={{ marginLeft: "10px" }}
                                  >
                                    ✓
                                  </button>
                                  <button
                                    className="confirnIcon"
                                    onClick={() => handleCancelAddChild(index)}
                                    style={{ marginLeft: "5px" }}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ) : (
                                <div className="add-another-child">
                                  Add Child
                                  <Button
                                    shape="circle"
                                    icon={<PlusOutlined />}
                                    size="small"
                                    style={{
                                      marginLeft: "6px",
                                      backgroundColor: "#9A4FE0",
                                      color: "white",
                                      border: "none",
                                      padding: "15px",
                                      fontSize: "12px",
                                      opacity:
                                        coParents[index]?.children?.length >= 3
                                          ? 0.5
                                          : 1,
                                      cursor:
                                        coParents[index]?.children?.length >= 3
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                    onClick={() => handleAddChild(index)}
                                    disabled={
                                      coParents[index]?.children?.length >= 3
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}

                  {coParents.length < 2 && (
                    <div
                      className="add-another"
                      style={{
                        textAlign: "center",
                        marginTop: "50px",
                        justifyContent: "center",
                        display: "none",
                      }}
                    >
                      Add another email
                      <Button
                        shape="circle"
                        icon={<PlusOutlined />}
                        size="small"
                        style={{
                          marginLeft: "6px",
                          backgroundColor: "#9A4FE0",
                          color: "white",
                          border: "none",
                          padding: "15px",
                          fontSize: "12px",
                        }}
                        onClick={addCoParent}
                      />
                    </div>
                  )}

                  {hasInvitesBeenSent ? (
                    <Button
                      type="primary"
                      className="modal-btn"
                      onClick={handleUpdate}
                      disabled={loading} // calls update API
                    >
                      {loading ? "Updating..." : "Update & Continue"}
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      className="modal-btn"
                      onClick={handleSubmit}
                      disabled={loading} // calls send API
                    >
                      {loading ? "Sending Invite..." : "Send Invite"}
                    </Button>
                  )}
                  <Button className="modal-btn-skip" onClick={handleSkip}>
                    Skip & Set Later
                  </Button>
                </div>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <div className="modal-content">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    style={
                      {
                        // display: `${step === 3 && !inviteStatus ? "none" : ""}`,
                      }
                    }
                    onClick={() => {
                      setStep(2);
                      setInviteStatus(true);
                    }}
                  >
                    Back
                  </Button>
                </div>

                <h2 className="modal-title-step2">
                  Set Up Your Parenting Schedule
                </h2>
                <img
                  src={coparent}
                  width={180}
                  style={{ marginBottom: "10px" }}
                />

                <div className="coparent-div coparent-div-1">
                  <Collapse
                    accordion
                    expandIcon={({ isActive }) => (
                      <DownOutlined
                        style={{ color: "#9A4FE0" }}
                        rotate={isActive ? 0 : 270}
                      />
                    )}
                    expandIconPosition="end"
                    bordered={false}
                    className="custom-collapse"
                  >
                    {parentCombinationsV2.map((combo) => (
                      <Panel
                        header={
                          <div className="collapse-header-text">
                            {combo.parent1.name ||
                              combo.parent1.nickname ||
                              "parent 1"}
                            -
                            {combo.parent2.name ||
                              combo.parent2.nickname ||
                              "Parent 2"}
                          </div>
                        }
                        key={combo.id}
                        headerClass="collapseHeader"
                        className="custom-panel"
                      >
                        <div className="custom-content-box">
                          {/* Parent 1 */}
                          <div className="parent-section">
                            <h3>Parent 1</h3>
                            <ColorDropdownWithName
                              value={combo.parent1.color}
                              name={combo.parent1.name}
                              onColorChange={(color) =>
                                updateParentFieldSet(
                                  combo.id,
                                  "parent1",
                                  "color",
                                  color
                                )
                              }
                              onNameChange={(name) =>
                                updateParentFieldSet(
                                  combo.id,
                                  "parent1",
                                  "name",
                                  name
                                )
                              }
                              disabledColor={combo.parent2.color}
                              usedColors={getAllUsedColors()}
                            />

                            <div className="add-coparent">
                              {/* <Input
              className="coParentEmail"
              readOnly
                value={combo.parent1.email}
                onChange={(e) => updateParentFieldSet(combo.id, 'parent1', 'email', e.target.value)}
              /> */}
                              <Form.Item className="floatLabelCoprent">
                                <FloatLabel
                                  label="Email"
                                  value={combo.parent1.email}
                                >
                                  <Input
                                    value={combo.parent1.email}
                                    className="coParentEmail"
                                    placeholder=""
                                    readOnly
                                    style={{ width: "100%" }}
                                    onChange={(e) =>
                                      updateParentFieldSet(
                                        combo.id,
                                        "parent1",
                                        "email",
                                        e.target.value
                                      )
                                    }
                                  />
                                </FloatLabel>
                              </Form.Item>
                            </div>
                          </div>

                          {/* Parent 2 */}
                          <div className="parent-section">
                            <h3>Parent 2</h3>
                            <ColorDropdownWithName
                              value={combo.parent2.color}
                              name={combo.parent2.name}
                              onColorChange={(color) =>
                                updateParentFieldSet(
                                  combo.id,
                                  "parent2",
                                  "color",
                                  color
                                )
                              }
                              onNameChange={(name) =>
                                updateParentFieldSet(
                                  combo.id,
                                  "parent2",
                                  "name",
                                  name
                                )
                              }
                              disabledColor={combo.parent1.color}
                              usedColors={getAllUsedColors()}
                            />

                            <div className="add-coparent">
                              {/* <Input
                readOnly
                className="coParentEmail"
                value={combo.parent2.email}
                onChange={(e) => updateParentFieldSet(combo.id, 'parent2', 'email', e.target.value)}
              /> */}
                              <Form.Item className="floatLabelCoprent">
                                <FloatLabel
                                  label="Email"
                                  value={combo.parent2.email}
                                >
                                  <Input
                                    value={combo.parent2.email}
                                    className="coParentEmail"
                                    placeholder=""
                                    readOnly
                                    style={{ width: "100%" }}
                                    onChange={(e) =>
                                      updateParentFieldSet(
                                        combo.id,
                                        "parent2",
                                        "email",
                                        e.target.value
                                      )
                                    }
                                  />
                                </FloatLabel>
                              </Form.Item>
                            </div>
                          </div>

                          <div
                            className="parentScheduleCheck"
                            style={{ marginBottom: "16px" }}
                          >
                            <h3>Parenting Schedule</h3>
                            <Checkbox
                              checked={combo.sameScheduleForAll}
                              onChange={(e) =>
                                sameScheduleForAllChange(
                                  combo.id,
                                  e.target.checked
                                )
                              }
                            >
                              Apply the same schedule to all children
                            </Checkbox>
                          </div>

                          {combo.sameScheduleForAll ? (
                            <div className="switch-selection">
                              <div
                                className="btn-switch"
                                onClick={() => handleOpenModal(combo.id)}
                              >
                                <div style={{ paddingBottom: "5px" }}>
                                  <p
                                    style={{
                                      margin: "0px",
                                      fontSize: "18px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Choose Days
                                  </p>
                                  <p
                                    style={{
                                      margin: "0px",
                                      fontSize: "12px",
                                      color: "#767A83",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        combo?.scheduleType?.label ||
                                        "No Days selected",
                                    }}
                                  />{" "}
                                </div>
                                <Switch checked={combo?.scheduleType?.id} />
                              </div>
                              <div
                                className="btn-switch"
                                onClick={() => handleOpenModalTime(combo.id)}
                              >
                                <div style={{ paddingBottom: "5px" }}>
                                  <p
                                    style={{
                                      margin: "0px",
                                      fontSize: "18px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Pick-up and drop-off times
                                  </p>
                                </div>
                                <Switch checked={getTimeSechudule(combo.id)} />
                              </div>
                            </div>
                          ) : (
                            <Collapse
                              accordion
                              expandIconPosition="end"
                              className="child-collapse"
                              expandIcon={({ isActive }) => (
                                <DownOutlined
                                  style={{ color: "#ffffff" }}
                                  rotate={isActive ? 0 : 270}
                                />
                              )}
                            >
                              {combo.children.map((child) => (
                                <Panel
                                  key={child.id}
                                  header={
                                    <div className="child-header">
                                      {child.name}
                                    </div>
                                  }
                                  headerClass="child-panel-header"
                                >
                                  <div className="switch-selection">
                                    <div
                                      className="btn-switch"
                                      onClick={() =>
                                        handleOpenModal(
                                          combo.id,
                                          child.id,
                                          combo
                                        )
                                      }
                                    >
                                      <div style={{ paddingBottom: "5px" }}>
                                        <p
                                          style={{
                                            margin: "0px",
                                            fontSize: "18px",
                                            marginBottom: "5px",
                                          }}
                                        >
                                          Choose Days
                                        </p>
                                        <p
                                          style={{
                                            margin: "0px",
                                            fontSize: "12px",
                                            color: "#767A83",
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              child?.scheduleType?.label ||
                                              "No Days selected",
                                          }}
                                        />
                                      </div>
                                      <Switch
                                        checked={child?.scheduleType?.id}
                                        // Check if scheduleType exists and set switch accordingly
                                      />
                                    </div>
                                    <div
                                      className="btn-switch"
                                      onClick={() =>
                                        handleOpenModalTime(combo.id, child.id)
                                      }
                                    >
                                      <div style={{ paddingBottom: "5px" }}>
                                        <p
                                          style={{
                                            margin: "0px",
                                            fontSize: "18px",
                                            marginBottom: "5px",
                                          }}
                                        >
                                          Pick-up and drop-off times
                                        </p>
                                        {/* <p
                                          style={{
                                            margin: "0px",
                                            fontSize: "12px",
                                            color: "#767A83",
                                          }}
                                        >
                                          <strong>
                                            {combo?.parent1?.name}
                                          </strong>{" "}
                                          Pickup:{" "}
                                          {child?.parent1Pickup?.time || ""},
                                          Dropoff:{" "}
                                          {child?.parent1Dropoff?.time || ""}{" "}
                                          <br />
                                          <strong>
                                            {combo?.parent2?.name}
                                          </strong>{" "}
                                          Pickup:{" "}
                                          {child?.parent2Pickup?.time || ""},
                                          Dropoff:{" "}
                                          {child?.parent2Dropoff?.time || ""}
                                        </p> */}
                                      </div>
                                      <Switch
                                        // checked={
                                        //   child?.parent1Pickup?.time &&
                                        //   child?.parent1Dropoff?.time &&
                                        //   child?.parent2Pickup?.time &&
                                        //   child?.parent2Dropoff?.time
                                        //     ? true
                                        //     : false
                                        // }
                                        checked={getTimeSechudule(
                                          combo.id,
                                          child.id
                                        )}
                                      />
                                    </div>
                                  </div>
                                </Panel>
                              ))}
                            </Collapse>
                          )}
                        </div>
                      </Panel>
                    ))}
                  </Collapse>

                  <Button
                    type="primary"
                    className="modal-btn"
                    onClick={handleSubmitSchedule}
                    disabled={loading}
                  >
                    {loading ? "Saving schedule" : "Save and Continue"}
                  </Button>
                  <Button className="modal-btn-skip" onClick={() => setStep(4)}>
                    Skip & Set Later
                  </Button>
                </div>
              </div>
            </>
          )}

          {step === 4 && (
            <>
              <div className="modal-content">
                {/* <div style={{width:'100%',display:'flex',justifyContent:'end'}}>
                          <Button onClick={() => setStep(3)}>Back</Button>
                          </div> */}
                <h2 className="modal-title-step2">Stay Notified</h2>
                <img
                  src={coparent}
                  width={180}
                  style={{ marginBottom: "10px" }}
                />
                <div className="switch-selection">
                  <div className="btn-switch">
                    <div style={{ paddingBottom: "5px" }}>
                      Push Notifications
                    </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={notificationSettings.push === 1}
                        onChange={(checked) =>
                          setNotificationSettings({
                            ...notificationSettings,
                            push: checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="btn-switch">
                    <div style={{ paddingBottom: "5px" }}>Email Summaries </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={notificationSettings.email === 1}
                        onChange={(checked) =>
                          setNotificationSettings({
                            ...notificationSettings,
                            email: checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="btn-switch">
                    <div style={{ paddingBottom: "5px" }}>Calender Sync </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={notificationSettings.calendar === 1}
                        onChange={(checked) =>
                          setNotificationSettings({
                            ...notificationSettings,
                            calendar: checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div
                    className="btn-switch"
                    onClick={() => setModalVisible(true)}
                  >
                    <div style={{ paddingBottom: "5px" }}>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "18px",
                          marginBottom: "5px",
                        }}
                      >
                        Reminder Timing
                      </p>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "12px",
                          color: "#767A83",
                        }}
                      >
                        {notificationSettings.reminderEnabled
                          ? notificationSettings.reminder_offset == 60
                            ? "1 hour"
                            : notificationSettings.reminder_offset == 1440
                            ? "1 day"
                            : `${notificationSettings.reminder_offset} minute(s)`
                          : "Not set"}
                      </p>
                    </div>
                    <div style={{ paddingBottom: "5px" }}>
                      <Switch
                        checked={
                          notificationSettings.reminderEnabled ? true : false
                        }
                        disabled={
                          !!(
                            reminder &&
                            (reminder.days > 0 ||
                              reminder.hours > 0 ||
                              reminder.minutes > 0)
                          )
                        }
                        onChange={(checked) => {
                          if (checked) {
                            // ✅ Open modal when toggled ON
                            setModalVisible(true);

                            // if no previous value, set a temporary default (like 5 mins)
                            if (!notificationSettings.reminderEnabled) {
                              setNotificationSettings({
                                ...notificationSettings,
                                reminder_offset: 0,
                              });
                            }
                          } else {
                            // ✅ When toggled OFF → clear reminder
                            setNotificationSettings({
                              ...notificationSettings,
                              reminder_offset: 0,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <ReminderModal
                  show={modalVisible}
                  onSave={(minutes) => {
                    setNotificationSettings({
                      ...notificationSettings,
                      reminderEnabled: true, // <-- just flag enabled
                      reminder_offset: minutes, // <-- minutes go here
                    });
                  }}
                  initialMinutes={notificationSettings?.reminder_offset}
                  onCancel={() => setModalVisible(false)}
                  handleClose={() => setModalVisible(false)}
                />
                <Button
                  type="primary"
                  className="modal-btn"
                  onClick={saveNotification}
                  disabled={loading}
                >
                  {loading ? "Saving notifications setup" : "Finish Setup"}
                </Button>
                <Button className="modal-btn-skip" onClick={skipAndClose}>
                  Skip & Use Default Settings
                </Button>
              </div>
            </>
          )}
        </Modal>

        {step === 5 && (
          <>
            <CoParentCalendarNew
              onSelect={handleSelect}
              coParentsMetaData={coParentsMetaData}
              getCoparentMetaData={getCoparentMetaData}
            />
          </>
        )}

        <div>
          {isModalOpenChooseDay && (
            <ChooseDays
              open={isModalOpenChooseDay}
              onClose={() => setIsModalOpenChooseDay(false)}
              activeComboId={activeComboId}
              activeChildId={activeChildId}
              parentCombinations={parentCombinations}
              sameScheduleForAll={sameScheduleForAll}
              scheduleTypeOptions={scheduleTypeOptions}
              onSave={handleSaveDays}
            />
          )}
          {isModalOpenChooseTime && (
            <ChooseTime
              open={isModalOpenChooseTime}
              onClose={() => setIsModalOpenChooseTime(false)}
              activeComboId={activeComboId}
              activeChildId={activeChildId}
              parentCombinations={parentCombinations}
              sameScheduleForAll={sameScheduleForAll}
              parentCombinationsV2={parentCombinationsV2}
              setParentCombinationsV2={setParentCombinationsV2}
              onSave={handleSaveTime}
              setParentCombinations={setParentCombinations}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AddCoParent;
